export default class LightController {
  constructor(game, location) {
    this.game = game;
    this.location = location;

    this.ambient = 1;
    this.prevAmbient = 1;
    this.changed = true;

    this.lights = []; // list of lights
    this.lightsPrev = [];
  }

  checkLights() {
    let changed = this.ambient !== this.prevAmbient;
    if (!changed && this.ambient < 1) {
      // check other light sources only at night
      const len = this.lights.length;
      for (let i = 0; i < len; i++) {
        const light = this.lights[i].getLight();
        const prevLight = this.lightsPrev[i];
        if (light.power !== prevLight.power || light.x !== prevLight.x || light.y !== prevLight.y) {
          changed = true;
          this.lightsPrev[i] = { ...light };
          break;
        }
      }
    }
    this.prevAmbient = this.ambient;
    this.changed = changed;
  }

  setDay(instant) {
    if (instant) {
      this.ambient = 1;
    } else {
      this.game.add.tween(this).to({ ambient: 1 }, 500, null, true);
    }
  }

  setNight(instant) {
    if (instant) {
      this.ambient = 0;
    } else {
      this.game.add.tween(this).to({ ambient: 0 }, 500, null, true);
    }
  }

  addLight(object) {
    this.lights.push(object);
    this.lightsPrev.push(object.getLight()); // store current value of the light
  }

  getLightAt(x, y, ambientOnly = false) {
    // no change
    if (!this.changed) return -1;

    //
    let power = this.ambient;

    // if power less than 1 check other light sources
    if (power < 1 && !ambientOnly) {
      const len = this.lights.length;
      let i = 0;
      while (i < len && power < 1) {
        const light = this.lights[i].getLight();

        const dx = Math.abs(light.x - x);
        if (dx < light.w) {
          const dy = Math.abs(light.y - y);
          if (dy < light.h) {
            // point in light range
            const p = light.power * (1 - dx / light.w) * (1 - dy / light.h);
            power += p;
            power = Math.min(power, 1);
          }
        }
        i++;
      }
    }

    return power;
  }
}
